
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"33","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.667 7.22a2.667 2.667 0 11-5.333 0C1.333 5.753 4 1.887 4 1.887s2.667 3.86 2.667 5.333zM28 31.887h-6l1.621-6.486a2 2 0 011.94-1.514h2.878a2.001 2.001 0 011.94 2.485L30 27.887M9 19.887l-2.8-7M2 12.887L6.79 24.86M12.414 23.301L9 19.887 5.647 27.43a2 2 0 00.628 2.412L9 31.887M21.015 22.928l-5.599 8.959M21.04 12.317a2 2 0 011.376 1.903v5.667a4 4 0 11-8 0V14.22a2 2 0 011.376-1.9 8.203 8.203 0 015.248-.003v0zM14.416 16.887a8.5 8.5 0 018 0M18.416 7.887v4M13.416 9.641l2.197 2.744M11 12.887l3.416 1.381M23.416 9.641l-2.196 2.744M25.832 12.887l-3.398 1.374","stroke":"#333234","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M27.667 27.887H31v4h-3.333A.667.667 0 0127 31.22v-2.667a.666.666 0 01.667-.666zM1 12.887h7","stroke":"#333234","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    